import { Injectable } from '@angular/core';
import { DecisionData } from '@entscheidungsnavi/decision-data';
import { ProjectService } from './project';

@Injectable({
  providedIn: 'root',
})
export class E2EHelperService {
  constructor(decisionData: DecisionData, projectService: ProjectService) {
    (window as any)['DecisionData'] = decisionData;
    projectService.project$.subscribe(() => {
      (window as any)['ProjectType'] = projectService.getProjectType();
    });
  }
}
